/**
 * Initializes modules, which are used across all pages in app.
 */
import { injectHeaderCampaigns } from '../organizedByType/initializers/campaigns/initCampaigns'
import initGlobalPromiseRejectionHandler from '../organizedByType/initializers/initGlobalRejectionHandler'

initGlobalPromiseRejectionHandler()
injectHeaderCampaigns()



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/bootstrap_common.js